module.exports = __webpack_public_path__ + "static/media/showMoreIcon.1380d901.svg";